import { render, staticRenderFns } from "./service-list.vue?vue&type=template&id=011fb93e&scoped=true&"
import script from "./service-list.vue?vue&type=script&lang=js&"
export * from "./service-list.vue?vue&type=script&lang=js&"
import style0 from "./service-list.vue?vue&type=style&index=0&id=011fb93e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011fb93e",
  null
  
)

export default component.exports